export default "__VITE_ASSET__CqVBi238__"